<template>
  <v-container :id="item.permalink">
    <v-row v-if="$breakpoint.is.smAndUp">
      <v-col tag="h3" cols="3" lg="2" offset="1" class="pt-11">
        Optie {{ index + 1 }}:<br>
        {{ item.title }}
      </v-col>
      <v-col cols="6" offset="1">
        <div class="option ml-n10 mb-12" v-html="item.description"/>
      </v-col>
    </v-row>
    <v-row v-else class="option ml-3">
      <v-col cols="12" tag="h3">
        Optie {{ index + 1 }}:<br>
        {{ item.title }}
      </v-col>
      <v-col>
        <div class="mb-12" v-html="item.description"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="sass" scoped>
.option
  position: relative
  @media screen and (min-width: map-get($grid-breakpoints, 'lg'))
    columns: 2
    column-gap: 60px

  &::before
    content: ''
    position: absolute
    top: 0
    height: 299px
    left: -10px
    width: 4px
    background-image: url('~assets/img/line.png')
    @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
      height: 180px
      left: -10%
</style>
